module.exports = __webpack_public_path__ + "media/images/favicons/mstile-310x310-47ad22f07ebffcd318abd17accbc9458.png";